import { InlineBanner } from "components/ui/inline-banner";
import { defaultLinkStyle } from "components/ui/link";
import { useGetSmtpCredentialForUserQuery } from "generated/graphql";
import React from "react";
import { Link } from "react-router-dom";
import { useFeature } from "store/selectors/hooks";
import { stableQueryOptions } from "util/requests";

export const SmtpMissingWarningBanner: React.FC = () => {
    const featureEnabled = useFeature("smtpMissingWarning");
    const smtpQuery = useGetSmtpCredentialForUserQuery({}, stableQueryOptions());

    if (!featureEnabled) {
        return null;
    }

    if (!smtpQuery.data) {
        return null;
    }

    if (smtpQuery.data.getSmtpCredentialForUser) {
        return null;
    }

    return (
        <InlineBanner type="warning">
            You haven&apos;t enabled Email Send Integration, which can result in email
            delivery issues.{" "}
            <Link className={defaultLinkStyle} to="/settings/account/email">
                Connect your email provider now.
            </Link>
        </InlineBanner>
    );
};
